export var DEPLOY_DATE = new Date('2026-08-27T00:20:00+0000');
